import EventEmitter from 'eventemitter3';
import { createWorkletModuleUrl } from "../utils";
import {logger} from '../utils/logger.js';




class AudioCollection extends EventEmitter {

    player = undefined;
    audioContext = undefined;
    collecting = false;
    userMediaStream = undefined
    mediaStreamSource = undefined
    hasRegisterTalkProcessor = false

    tag = 'AudioCollection' 

    constructor(player) {

        super()

        this.player = player;

        this.audioContext = new (window.AudioContext || window.webkitAudioContext)({sampleRate: 8000})

        this.registerTalkProcessor()

        logger.info(this.tag, 'created');
    }


    async start() {

        if (this.collecting) {

            logger.warn(this.tag, 'start, but now is audio collecting, ingore');
            
            throw 'AudioCollection has started, not handle'
        }

        // 消音器
        // this.biquadFilter = this.audioContext.createBiquadFilter();
        // this.biquadFilter.type = "lowpass";
        // this.biquadFilter.frequency.value = 3000;
             
        if (this.player.options.audioEngine == 'worklet') {

            this.workletNode = await this.createWorkletNode()

        } else {

            logger.warn(this.tag, 'now url not https, worklet not work');
            
            throw 'url not https or use audio script engine, worklet not work'
            // this.scriptNode = this.createScriptNode()
        }

        let stream = await window.navigator.mediaDevices.getUserMedia({
            audio:  {
                latency: true,
                noiseSuppression: true, // 降噪
                autoGainControl: true,
                echoCancellation: true, // 回声消除
                sampleRate: 8000,
                channelCount: 1
            },
            video: false
        })


        if (stream) { //audiodata : microphone -> biquadfilter -> audionode

            logger.info(this.tag, 'getUserMedia success');
            this.userMediaStream = stream;
            this.mediaStreamSource = this.audioContext.createMediaStreamSource(stream)
           // this.mediaStreamSource.connect(this.biquadFilter);
           
            let audioNode = this.workletNode
            this.mediaStreamSource.connect(audioNode)
           // this.biquadFilter.connect(audioNode)
            // audioNode.connect(this.gainNode)
            // this.gainNode.connect(this.audioContext.destination)

            logger.info(this.tag, 'start success');

            this.collecting = true

        } else {

            logger.info(this.tag, 'start faile, can not get micro stream');
            
            throw 'can not get micro stream'

        }
 
    }

    getMessagePort() {

        return this.workletNode?.port

    }

    stop() {

        if (!this.collecting) {

            logger.warn(this.tag, 'stop, but now audio is not collecting, ingore');
            return
        }

        if (this.userMediaStream) {
            this.userMediaStream.getTracks && this.userMediaStream.getTracks().forEach((track) => {
                track.stop()
            })
            this.userMediaStream = null;
        }

        if (this.workletNode) {
            this.workletNode.disconnect();
            this.workletNode = null;
        }

        this.collecting = false
        // if (this.biquadFilter) {
        //     this.biquadFilter.disconnect();
        //     this.biquadFilter = null;
        // }

        logger.info(this.tag, 'AudioCollection stop success');

    }

    destroy() {

        this.stop()
  
        this.audioContext = null;

        logger.info(this.tag, 'AudioCollection destroy');
    }

    // createScriptNode() {
    //     this.scriptChannle = new MessageChannel();
    //     // const createScript = this.audioContext.createScriptProcessor || this.audioContext.createJavaScriptNode;
    //     // let scriptNode = createScript.apply(this.audioContext, [256, 1, 0])


    //      let scriptNode =  this.audioContext.createScriptProcessor(256, 1, 1)
    //     scriptNode.onaudioprocess = (e) => {
            
    //         let audioData = fltpToPcmALaw(e.inputBuffer.getChannelData(0))
            
    //         this.scriptChannle.port1.postMessage({
    //             message: "data",
    //             audioData
    //         }, [audioData.buffer]);

    //     };

    //     return scriptNode
    // }


    async registerTalkProcessor() {

        function workletProcess() {

            function fltpToPcmALaw(floatArray) {
                const alawArray = new Uint8Array(floatArray.length);
                for(let i = 0; i < floatArray.length; i++) {
                  const floatVal = floatArray[i];
                  // convert range from -1.0 ~ 1.0 to -32768 ~ 32767
                  let intVal = Math.floor(floatVal * 32767.0);
                  // clamp to allowed range
                  if (intVal < -32768) {
                    intVal = -32768;
                  } else if (intVal > 32767) {
                    intVal = 32767;
                  }
                  // convert to alaw
                  let sign = (intVal < 0) ? 0x80 : 0x00;
                  if (sign) intVal = -intVal - 1;
                  let exponent = Math.floor(Math.log2(intVal)) >> 1;
                  let mantissa = (intVal >> (7 - exponent)) & 0x0F;
                  let alawVal = (sign | exponent << 4 | mantissa);
                  alawArray[i] = alawVal ^ 0x55;
                }
                return alawArray;
              }
            

            class TalkProcessor extends AudioWorkletProcessor {

                constructor(options) {
                    super();
                }

                process(inputs, outputs, parameters) {
                    if (!inputs.length || !inputs[0].length) {
                        return true;
                    }
                 
                    let audioData = fltpToPcmALaw(inputs[0][0])

                    this.port.postMessage({
                        message: "data",
                        audioData
                    }, [audioData.buffer]);


                    return true;
                }
            }

            registerProcessor('talk-processor', TalkProcessor)
        }

        const workletUrl = createWorkletModuleUrl(workletProcess);

        await this.audioContext.audioWorklet.addModule(workletUrl)

        URL.revokeObjectURL(workletUrl);
        this.hasRegisterTalkProcessor = true;
    }

    async createWorkletNode() {

        let task = new Promise((resolve) => {

            if (this.hasRegisterTalkProcessor) {

                resolve()
                return
            }

            let timer = setInterval(()=>{

                if (this.hasRegisterTalkProcessor) {

                    clearInterval(timer)
                    resolve()
                    return
                }

            }, 10)

        })

        await task

        let workletNode = new AudioWorkletNode(this.audioContext, 'talk-processor', {
            processorOptions: {
                // bufferSize: this.bufferSize
            }
        })

        return workletNode
    }

}


export default AudioCollection;